<template>
  <Searchbox @search="redditSearch" :inSearch="term" :inSort="sort" :inLimit="limit" />
  <div v-if="searchData" class="row row-cols-1 row-cols-md-3 g-4">
      <div class="col" v-for="data in searchData" :key="data.id">
          <Resultcard :data="data"/>
      </div>
  </div>
  <div class="anim-wrapper" v-else>
      <div class="pulse-spinner"></div>

  </div>
</template>

<script>
import Searchbox from "../components/Searchbox";
import Resultcard from '../components/Resultcard';
export default {
  components: {
    Searchbox, Resultcard
  },
  props: {
    term: String,
    sort: String,
    limit: String,
  },
  data(){
      return {
          searchData : null,
      }
  },
  methods:{
      redditSearch(searchInput, sort, limit) {
      this.$router.push({
        name: "Search",
        params: { term: searchInput, sort, limit },
      });
  }},
  async mounted(){
      let res = await fetch(
      `https://www.reddit.com/search.json?q=${this.term}&sort=${this.sort}&limit=${this.limit}`
    )
      let data = await res.json()
      this.searchData = data.data.children.map(data => data.data)
      //console.log(this.searchData)
  }
};
</script>

<style>
.anim-wrapper{
    width: 100%;
    height: 20vh;
    display: grid;
    place-items: center;
    
}

.pulse-spinner{
    height: 90px;
    width: 90px;
    border-radius: 50%;
    background-color: #F5853F;
}
.pulse-spinner::after{
    content: "";
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background-color: #F5853F;
    z-index: 1;
    position: absolute;
    animation: pulse 1s ease       infinite;
}
@keyframes pulse {
    from{
        transform: scale(1);
        opacity: 1;
    }
    to{
        transform: scale(2);
        opacity: 0;
    }
    
}
</style>